
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(3(09|15|75)|538|658)|16(06|7)|7(549|570|700|747|881|959)|3(506|564|737|977)|[29]387|6269|6929|842|8668|9721)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
